export { default as ClassForm } from './ClassFormContainer';



// WEBPACK FOOTER //
// ./src/components/Admin/ClassForm/index.js